








import { Component, Prop, Vue } from "vue-property-decorator";
import { AbsenceTypeViewModel } from "@/services/api/nswag/stapiclient_generated";

@Component
export default class OwnAbsences extends Vue {
  @Prop() absenceType!: AbsenceTypeViewModel;
}

